import React from 'react';

import Page from 'components/Page.js';
import PhoneHelpBar from 'components/PhoneHelpBar';
import { brokerageFlow } from '../flows';
import BrokerageFormFlow from './BrokerageFormFlow';


const BrokerageFlow = () => {
  return (
    <Page title="Clickability Service Request">
      <BrokerageFormFlow flow={brokerageFlow} defaultsToLastValidPage />
      <PhoneHelpBar />
    </Page>
  );
};

export default BrokerageFlow;